import SaveButton from "@/components/ui/SaveButton";

export interface SkillCollectionSaveButtonProps {
  disabled: boolean;
  hasUnsavedChanges: boolean;
  isSaving: boolean;
  onClick: () => void;
  tooltipContent: string;
  className?: string;
}

export const SkillCollectionSaveButton = ({
  disabled,
  hasUnsavedChanges,
  isSaving,
  onClick,
  tooltipContent,
  className,
}: SkillCollectionSaveButtonProps) => (
  <SaveButton
    label="Save Version"
    size="sm"
    disabled={disabled}
    hasUnsavedChanges={hasUnsavedChanges}
    isSaving={isSaving}
    onClick={e => {
      e.preventDefault();
      onClick();
    }}
    tooltipContent={tooltipContent}
    className={className}
  />
);
